import axios from 'axios';
import * as Stats from '../stats';
import {
    IOS_FETCH_REVIEWS_API
} from './constants';

/**
 * Fetches reviews from apple itunes API.
 * @return {Promise<AppReviews>}
 */
const getIosReviews = async() => {
    try {
        const { data: { results = [] } } = await axios.get(IOS_FETCH_REVIEWS_API);
        const [firstRecord = {}] = results;

        const { averageUserRating, userRatingCount } = firstRecord;

        return { ratings: averageUserRating, reviews: userRatingCount };
    } catch (error) {
        Stats.count(Stats.METRICS.API_FETCH_IOS_REVIEWS_ERROR);

        return {};
    }
};

/**
 * Fetches reviews from android playstore API.
 * TODO - Implement this API once ready.
 * @return {Promise<AppReviews>}
 */
const getAndroidReviews = async() => ({});

/**
 * Return Fiverr native app reviews from a specific os API (itunes / playstore).
 * @param {Boolean} isIos Whether current os is Ios or not.
 * @return {Promise<AppReviews>}
 */
export const getReviews = (isIos = false) => isIos ? getIosReviews() : getAndroidReviews();
